import { Component, ElementRef, inject, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { FuseNavigationModule } from "@fuse/components";
import { FuseDirectivesModule } from "@fuse/directives/directives";
import { MatButtonModule } from "@angular/material/button";
import { AppSessionService } from "@vadmin/account/auth";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";
import { filter, Subject, takeUntil } from "rxjs";

@Component({
    selector: "v2-navbar",
    templateUrl: "./v2-navbar.component.html",
    styleUrls: ["./v2-navbar.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, FuseNavigationModule, FuseDirectivesModule],
})
export class V2NavbarComponent implements OnInit, OnDestroy {
    // Private
    private _unsubscribeAll = new Subject<void>();

    private _variant: string;

    private _sessionService = inject(AppSessionService);

    private _fuseNavigationService = inject(FuseNavigationService);

    tenantName: string;

    navigation: any;

    /**
     * Constructor
     *
     * @param {ElementRef} _elementRef
     * @param {Renderer2} _renderer
     */
    constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {
        // Set the private defaults
        this._variant = "vertical-style-1";
    }

    ngOnInit(): void {
        if (this._sessionService.tenant !== undefined) {
            this.tenantName = this._sessionService.tenant.name;
        }

        this._fuseNavigationService.onNavigationChanged
            .pipe(
                filter((value) => value !== null),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe(() => {
                this.navigation = this._fuseNavigationService.getCurrentNavigation();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Variant
     */
    get variant(): string {
        return this._variant;
    }

    @Input()
    set variant(value: string) {
        // Remove the old class name
        this._renderer.removeClass(this._elementRef.nativeElement, this.variant);

        // Store the variant value
        this._variant = value;

        // Add the new class name
        this._renderer.addClass(this._elementRef.nativeElement, value);
    }
}
